<template>
  <div class="doc-app">
    <div class="doc-app__heading p-3">
      <div class="is-flex is-justify-content-end">
        <aq-button size="small" outline class="mr-2" @click="changeLang('es')">ESP</aq-button>
        <aq-button size="small" outline @click="changeLang('en')">ENG</aq-button>
      </div>
      <div class="doc-app__heading-logo">
        <img src="./assets/images/Logo_horizontal_color light_RGB@4x.png" alt="trusense-logo">
      </div>
    </div>
    <div class="doc-app__body">
      <div class="is-flex doc-app__body-introduction is-align-items-center">
        <img
          alt="principal-img"
          src="https://dqxgrni3t2zc8.cloudfront.net/images/branding/trusense11.png"
        >
        <div class="doc-app__left-content">
          <aq-heading>{{ $t('documentation.headingTitle') }}</aq-heading>
          <div
            class="mt-5 doc-app__introduction"
            v-html="$t('documentation.introduction')"
          ></div>
        </div>
      </div>
      <aq-divider class="doc-app__divider"></aq-divider>
      <div class="doc-app__body-products">
        <product-card
          class="mb-5 pb-5"
          scope-product="TruScore"
          :products="truScoreProduct"
          :scope-product-hlp-txt="$t('documentation.truscore')"
        ></product-card>
        <product-card
          scope-product="TruAuth"
          :products="truAuthProduct"
          :scope-product-hlp-txt="$t('documentation.truauth')"
        ></product-card>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';

import { TruSenseLangHelper } from '@trusense/language';

const ProductCard = () => import(/* webpackChunkName: "ProductCard" */ '@/components/ProductCard.vue');

const changeLang = (lang: string): void => {
  TruSenseLangHelper.changeLocale(lang);
};

const truScoreProduct = ref([
  {
    name: '',
    icon: '',
    description: '',
    userUrl: 'https://docs.trusense.dev/truscore-user-guide.pdf',
    apiUrl: 'https://www.notion.so/masivapp/API-Documentation-6e7b574d098a401e91f7cae4256c79bb?pvs=4',
    docUrl: 'https://www.notion.so/masivapp/TruScore-f8abe5b44ded47b69ace3c8c9ed5f388?pvs=4',
  },
]);

const truAuthProduct = ref([
  {
    name: 'MNV',
    icon: 'aq-icon-mnv',
    description: 'documentation.mnv',
    userUrl: 'https://docs.trusense.dev/mnv-guide.pdf',
    apiUrl: 'https://www.notion.so/masivapp/Get-start-with-docs-fe5b1a4105ea4baab43ac4007f8c78b0?pvs=4',
    docUrl: 'https://www.notion.so/masivapp/MNV-fd8163c2414a41719ae24c166cb04688?pvs=4',
  },
]);

onMounted(() => changeLang('en'));
</script>
